import React, { useEffect, useState, useMemo } from 'react';
import List from '@mui/material/List';
import MuvikaService from './../../services/muvika';
import CreatorsDialog from '../dialogs/CreatorsDialog';
import BackgroundMusicListItem from '../items/BackgroundMusicListItem';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import PerformanceListItem from '../items/PerformanceListItem';
import IntervalService from './../../services/intervals';
import BackgroundMusicEditPerformance from '../dialogs/BackgroundMusicEditPerformance';
import EditPerformance from '../dialogs/EditPerformance';
import singersStore from './../../stores/singers';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from './../../stores/favorites';
import settingsStore from '../../stores/settings';
import playerStore from './../../stores/player';
import bgPerformanceStore from '../../stores/bgPerformance';
import messageStore from '../../stores/message';
import musicPlayerStore from '../../stores/musicPlayer';

function BackgroundMusicList(props) {

  const sessionToken = sessionStore((state) => state.sessionToken);
  const settings = settingsStore((state) => state.settings);
  const getSettings = settingsStore((state) => state.getSettings);
  const getSingers = singersStore((state) => state.getSingers);
  const singers = singersStore((state) => state.singers);
  const movePerformance = bgPerformanceStore((state) => state.movePerformance);
  const setError = messageStore((state) => state.setError);
  const playQueueItems = bgPerformanceStore((state) => state.playQueue?.items);
  const playLists = bgPerformanceStore((state) => state.playLists);
  const editPerformance = bgPerformanceStore((state) => state.editPerformance);
  const addPerformanceToPlayList = bgPerformanceStore((state) => state.addPerformanceToPlayList);
  const setIsStopped = musicPlayerStore((state) => state.setIsStopped);
  const setIsSwitching = musicPlayerStore((state) => state.setIsSwitching);
  const setCurrentTime = musicPlayerStore((state) => state.setCurrentTime);
  const setIsPlaying = musicPlayerStore((state) => state.setIsPlaying);
  const setFrom = musicPlayerStore((state) => state.setFrom);

  const [isEditPerformanceOpen, setIsEditPerformanceOpen] = useState(false);
  const [chosenPerformance, setChosenPerformance] = useState({});

  const handleOpenEditPerformance = (performance) => {
    setChosenPerformance(performance);
    setIsEditPerformanceOpen(true);
  };

  const handleCloseEditPerformance = () => {
    setIsEditPerformanceOpen(false);
  };

  useEffect(() => {
    if (!settings) {
      getSettings(sessionToken);
    }
    if (!singers) {
      getSingers(sessionToken);
    }
  }, []);

  const playQueueItemIds = useMemo(() => {
    return playQueueItems?.map((p) => p.unique_id);
  }, [playQueueItems]);

  const musicList = useMemo(() => {
    if (playQueueItemIds) {
      return playQueueItemIds.map((performanceId, index) => {
        return <BackgroundMusicListItem
          key={`music-${performanceId}`}
          draggableId={`music-${performanceId}`}
          index={index}
          count={playQueueItemIds.length}
          onEditPerformance={(performance) => {
            handleOpenEditPerformance(performance);
          }}
        />
      }
      );
    }
  }, [playQueueItemIds]);

const handleDragEnd = (result) => {
  if (result.destination) {
    let source = result.source.index;
    let dest = result.destination.index;
    if (source != dest) {
      movePerformance(sessionToken, source, dest);
    }
  }
};

const handleEdit = (playList, pos, playNow) => {
  console.log(playList, pos);
  if (playList) {
    addPerformanceToPlayList(sessionToken, chosenPerformance.track, singers[0], playList.id, pos);
  } else {
    editPerformance(sessionToken, chosenPerformance.unique_id, singers[0], pos, playNow);
  }
  setIsEditPerformanceOpen(false);
};

const editPerformanceDialog = () => {
  if (chosenPerformance.track) {
    return <BackgroundMusicEditPerformance
      open={isEditPerformanceOpen}
      onClose={handleCloseEditPerformance}
      onEdit={handleEdit}
      playLists={playLists}
      performance={chosenPerformance}
    />;
  }
};

return (
  <div style={{ padding: 0 }}>
    {editPerformanceDialog()}
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="droppable-playqueue">
        {(provided, snapshot) => (
          <div {...provided.droppableProps} ref={provided.innerRef} >
            <List className="muvika-background-music-list">
              {musicList}
            </List>
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  </div>
);
}

export default BackgroundMusicList;